import { useQuery } from 'react-query'
import axios from 'axios'
import { API_URL } from '../../config'
import { rqDefaultOptions } from './defaultOptions'

const getAllLeadTimes = async (inputObj) => {
  const { limit, skip, email } = inputObj.queryKey[1]
  axios.defaults.headers.common['Authorization'] = email
  const AllLeadTimesAPIPath = `${API_URL}/api/leadTimes/v1/getAllLeadTimes?limit=${limit}&skip=${skip}`
  const res = await axios.get(AllLeadTimesAPIPath)
  return res.data
}

export function useAllLeadTimes(queryKey, limit = 20, skip = 0, email) {
  const options = {
    ...rqDefaultOptions,
  }
  return useQuery([queryKey, { limit, skip, email }], getAllLeadTimes, options)
}
